import {graphql, useStaticQuery} from "gatsby"
import {useContext} from "react"
import I18nContext from "~/contexts/I18nContext"

export const useAuthenticationLabelsQuery = () => {
    const i18n = useContext(I18nContext)

    const data: Queries.AuthenticationLabelsQuery = useStaticQuery(graphql`
        query AuthenticationLabels {
            allContentfulAuthenticationLabels {
                nodes {
                    node_locale
                    username
                    password
                    newPasswordSuccess
                    name
                    lastName
                    email
                    companyName
                    companyType
                    phoneNumber
                    role
                    attributesUpdateSuccess
                    confirmationMessage {
                        raw
                    }
                    passwordChangeMessage {
                        raw
                    }
                    resetMessage {
                        raw
                    }
                    signInMessage {
                        raw
                    }
                    signUpMessage {
                        raw
                    }
                    cognitoErrorMessage {
                        raw
                    }
                    confirmationCode
                    changePasswordButtonLabel
                    clickHereLinkLabel
                    completeRegistrationButtonLabel
                    confirmButtonLabel
                    forgottenPasswordQuestion
                    resendConfirmationCodeLinkLabel
                    resendConfirmationCodeQuestion
                    signInButtonLabel
                    signOutButtonLabel
                    signUpButtonLabel
                    validationInvalidConfirmationCode
                    validationInvalidCredentials
                    validationInvalidEmail
                    validationInvalidLastName
                    validationInvalidName
                    validationInvalidPassword
                    validationInvalidPasswordSpecs {
                        raw
                    }
                    validationInvalidPhoneNumber
                    alreadyHaveAccount
                    missingAccount
                    accountRequired {
                        raw
                    }
                    wellcome
                    cancelButtonLabel
                    newPassword
                    oldPassword
                    resetPasswordButtonLabel
                    updateFailed
                    validationInvalidVerificationCode
                    verificationCode
                    validationEmailAlreadyUsed
                    confirmAccountSuccess
                }
            }
            allContentfulAuthenticationLabels2 {
                nodes {
                    forgottenPasswordMessage {
                        raw
                    }
                    forgottenPasswordVerificationMessage {
                        raw
                    }
                    node_locale
                    update
                    updateAttributesMessage {
                        raw
                    }
                    attributesUpdateSuccess
                    deleteAccountMessage {
                        raw
                    }
                    deleteAccountButtonLabel
                    accountDeleteSuccess
                    updateAttributesButtonLabel
                    deleteAccount
                    backToTheHomepage
                    unkownErrorMessage
                    privateAreaAccessLinkMessage
                    privateAreaAccessMessage
                }
            }
        }
    `)

    let labelsData1 = data.allContentfulAuthenticationLabels.nodes[0]!
    let labelsData2 = data.allContentfulAuthenticationLabels2.nodes[0]!

    for (const translation of data.allContentfulAuthenticationLabels.nodes) {
        if (translation.node_locale === i18n.language) {
            labelsData1 = translation
            break
        }
    }

    for (const translation of data.allContentfulAuthenticationLabels2.nodes) {
        if (translation.node_locale === i18n.language) {
            labelsData2 = translation
            break
        }
    }

    const labelsData = {...labelsData1, ...labelsData2}

    return labelsData
}
